// extracted by mini-css-extract-plugin
module.exports = {"bg":"style_bg__PV5kO"};